import React from "react";
import { connect } from "react-redux";
import LimitLine from "../../GameHeader/Stats/LimitLine";
import { formatNumber, formatNumberForceSigned } from "../../../lib/commonFunctions";

const ManaBalance = ({ manaBalance }) => (
  <React.Fragment>
    <h3 className="title">Mana balance</h3>
    Druids: <span
    className={manaBalance.production.druids > 0 ? "positive"
      : ""}>{formatNumberForceSigned(manaBalance.production.druids)}</span><br/>
    {!!manaBalance.production.guilds && <>
      Guild: <span className={"positive"}>{formatNumberForceSigned(manaBalance.production.guilds)}</span><br />
    </>}
    <br />
    Magic studies: <span className={manaBalance.consumption > 0 ? "negative" : ""}>{formatNumber(-manaBalance.consumption)}</span>
    <br />
    <LimitLine
      amount={manaBalance.limit.amount}
      limit={manaBalance.limit.limit}
      market={manaBalance.limit.market}
    />
  </React.Fragment>
);

const mapStateToProps = state => ({
  manaBalance: state.governorate.resourceBalances.mana,
});

export default connect(mapStateToProps)(ManaBalance);
